import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { WEB_APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

// wallet - Get All (Read)

export const GetLedger = createAsyncThunk(
    "masters/wallet/get-ledger",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(`${WEB_APIS.Wallet.Ladger}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const GetAllBanks = createAsyncThunk(
    "masters/wallet/get-all",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${WEB_APIS.Wallet.Bank}?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&filter=${filter?.filter || ""}&sortBy=${filter?.sortBy || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// wallet - Get (Read)
export const GetSingleBank = createAsyncThunk(
    "masters/wallet/get",
    async ({ id, filter }, { rejectWithValue }) => {

        try {
            const res = await GET(`${WEB_APIS.Wallet.Bank}/${id}?startDate=${filter?.startDate || ""}&endDate=${filter?.endDate || ""}&transaction_type_id=${filter?.selectedType || ""}`);
            return res?.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const GetRecentTransactions = createAsyncThunk(
    "masters/wallet/get-ts",
    async (filter, { rejectWithValue }) => {

        try {
            const res = await GET(`${WEB_APIS.Wallet.RecentTrancation}?name=${filter?.name || ""}&endDate=${filter?.endDate || ""}&transaction_type_id=${filter?.selectedType || ""}&startDate=${filter?.startDate || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&filter=${filter?.filter || ""}&sortBy=${filter?.sortBy || ""}`);
            return res?.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// wallet - Create (Add)
export const CreateBank = createAsyncThunk(
    "masters/wallet/create-bank",
    async (data, { rejectWithValue }) => {
        try {
            const res = await POST(WEB_APIS.Wallet.Bank, data);

            if (res.success) {

                return res; // The new wallet object
            }
            return rejectWithValue(res);
        } catch (error) {

            return rejectWithValue(error.response.data);
        }
    }
);


export const TransaferBankMoney = createAsyncThunk(
    "masters/wallet/transafer-money",
    async (data, { rejectWithValue }) => {
        try {
            const res = await POST(WEB_APIS.Wallet.TransferMoney, data);

            if (res.success) {
                return res;
            }
            return rejectWithValue(res);
        } catch (error) {

            return rejectWithValue(error.response.data);
        }
    }
);
export const AddReduceMoney = createAsyncThunk(
    "masters/wallet/update-bank-money",
    async (data, { rejectWithValue }) => {
        try {
            const res = await POST(WEB_APIS.Wallet.UpdateMoney, data);

            if (res.success) {
                return res;
            }
            return rejectWithValue(res);
        } catch (error) {

            return rejectWithValue(error.response.data);
        }
    }
);

// wallet - Update
export const Update = createAsyncThunk(
    "masters/wallet/update-bank",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await PUT(`${WEB_APIS.Wallet.Bank}/${id}`, data);
            return res;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// wallet - Delete
export const Delete = createAsyncThunk(
    "masters/wallet/delete",
    async (id, { rejectWithValue }) => {
        try {
            const data = await DELETE(`${WEB_APIS.Wallet.Bank}/${id}`);
            return id; // Return the id of the deleted wallet
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// wallet - Status
export const Status = createAsyncThunk(
    "masters/wallet/status",
    async (id, { rejectWithValue }) => {
        try {
            const res = await POST(`${WEB_APIS.Masters.wallet}/${id}`);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


export const CreateNote = createAsyncThunk(
    "masters/wallet/createNote",
    async (data, { rejectWithValue }) => {
        try {
            const res = await POST(`${WEB_APIS.Masters.wallet}/note`, data);

            if (res.success) {

                return res; // The new wallet object
            }
            return rejectWithValue(res);
        } catch (error) {

            return rejectWithValue(error.response.data);
        }
    }
);

export const DeleteNote = createAsyncThunk(
    "masters/wallet/delete",
    async (id, { rejectWithValue }) => {
        try {
            const data = await DELETE(`${WEB_APIS.Masters.wallet}/note/${id}`);
            return id; // Return the id of the deleted wallet
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const Slice = createSlice({
    name: "wallet",
    initialState: {
        data: [],
        recent_transactions: [],
        current_page: IDS.PAGE,
        total_pages: IDS.TOTALPAGES,
        per_page: IDS.PERPAGE,
        total: IDS.TOTAL,
        status: IDS.SLICESTATUS.Idle,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handling all actions for GetSingleBank, Create, Update, Delete
            .addCase(GetAllBanks.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetAllBanks.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.data = action.payload?.data || [];
                state.current_page = action.payload?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.per_page || IDS.PERPAGE;
                state.total = action.payload?.total || IDS.TOTAL;
            })
            .addCase(GetAllBanks.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(GetRecentTransactions.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetRecentTransactions.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.recent_transactions = action.payload?.data || [];
                state.current_page = action.payload?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.per_page || IDS.PERPAGE;
                state.total = action.payload?.total || IDS.TOTAL;
            })
            .addCase(GetRecentTransactions.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(GetSingleBank.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetSingleBank.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
            })
            .addCase(GetSingleBank.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(GetLedger.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetLedger.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
            })
            .addCase(GetLedger.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(CreateBank.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(CreateBank.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data.unshift(action.payload.data);
            })
            .addCase(CreateBank.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })
            .addCase(TransaferBankMoney.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(TransaferBankMoney.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data.unshift(action.payload.data);
            })
            .addCase(TransaferBankMoney.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(AddReduceMoney.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(AddReduceMoney.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data.unshift(action.payload.data);
            })
            .addCase(AddReduceMoney.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Update.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Update.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                const index = state.data.findIndex(
                    (wallet) => wallet.id === action.payload?.data?.id
                );
                if (index !== -1) {
                    state.data[index] = action.payload.data;
                }
            })
            .addCase(Update.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Delete.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Delete.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data = state.data.filter(
                    (wallet) => wallet.id !== action.payload.id
                ); // Remove the wallet with the deleted id
            })
            .addCase(Delete.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })
            //
            .addCase(Status.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Status.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data = state.data.filter(
                    (wallet) => wallet.id !== action.payload.id
                ); // Remove the wallet with the deleted id
            })
            .addCase(Status.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            });
    },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
